module.exports = __webpack_public_path__ + "static/media/greenbackground.9cd07ec1.png";